module.exports = __webpack_public_path__ + "static/media/ill_andningsbesvar.c33b05d7.svg";